import { AuthConfig } from "angular-oauth2-oidc";
const url = window.location.href.includes("/en")
  ? window.location.origin + `/en/auth`
  : window.location.origin + `/ar/auth`;
const locale = window.location.href.includes("/en")
  ? "en"
  : window.location.href.includes("/ar")
  ? "ar"
  : sessionStorage.getItem("lang") == "en"
  ? "en"
  : "ar";
  
const logoutRedirectUrl = window.location.href.includes("/en")
  ? window.location.origin + `/en`
  : window.location.origin + `/ar`;
export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: "",
  // URL of the SPA to redirect the user to after login
  redirectUri: url,
  postLogoutRedirectUri: logoutRedirectUrl,
  // The SPA's id. The SPA is registered with this id at the auth-server
  clientId: "",
  responseType: "code",
  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  //scope: 'openid profile email offline_access',
  scope: "openid basic-profile basic-address email",
  disableAtHashCheck: true,
  skipIssuerCheck: true,
  strictDiscoveryDocumentValidation: false,
  customQueryParams: {
    response_mode: "query",
    kc_locale: locale,
    ui_locales: locale,
  },
  fallbackAccessTokenExpirationTimeInSec: 60,
  logoutUrl: `/protocol/openid-connect/logout?client_id={{client_id}}&id_token={{id_token}}&redirect_uri=${logoutRedirectUrl}`,
  silentRefreshTimeout: 60000, // For faster testing
  timeoutFactor: 0.75, // For faster testing
  sessionChecksEnabled: false,
  showDebugInformation: false, // Also requires enabling "Verbose" level in devtools
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040
};
